import {
  ClientRecord,
  InvoiceRecord,
  PetRecord,
  ServiceRecord,
  ServiceRenderedRecord,
  SettingsRecord,
  VetRecord,
} from "../types";

// A single mutable store shared by every in-memory repository so that data
// created on one page (e.g. services rendered) is visible on another
// (e.g. invoicing). State lives for the lifetime of the page — a browser
// reload starts from empty.
export interface InMemoryStore {
  clients: ClientRecord[];
  services: ServiceRecord[];
  servicesRendered: ServiceRenderedRecord[];
  invoices: InvoiceRecord[];
  vets: VetRecord[];
  pets: PetRecord[];
  settings: SettingsRecord;
}

let idCounter = 0;
export const nextId = (prefix: string): string => `${prefix}-${++idCounter}`;

export const store: InMemoryStore = {
  clients: [],
  services: [],
  servicesRendered: [],
  invoices: [],
  vets: [],
  pets: [],
  settings: {
    id: "e2e-settings",
    mileageCost: 45,
    invoicePrefix: "INV",
    invoiceNumber: 1,
    companyDetails: {
      name: "E2E Test Co",
      address: "1 Test Street",
      town: "Testington",
      postCode: "TE1 1ST",
    },
    emailSettings: {
      subject: "Latest Invoice",
      defaultText: "Dear [client_name], \n Please find attached your latest invoice.",
    },
    subscription: {
      subscribed: true,
      subscriptionActive: true,
      validTo: "2099-01-01",
    },
  },
};
